import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
interface Bono {
  bono: string;
  title: string;
  image?: string;
  items: string[];
}
const bonos: Bono[] = [{
  bono: '🎁 Bono 1',
  title: '📅 Planes de Entrenamiento Listos Para Usar',
  image: 'https://cdn.magicpatterns.com/uploads/5rPdin4s2m3TVCyUDWqDZU/Screenshot_2026-06-06_at_1.40.16_PM.png',
  items: ['Plan Sprint para principiantes', 'Plan Olímpico para principiantes', 'Plan de 4 días semanales', 'Plan de 5 días semanales', 'Plan de 6 días semanales', 'Progresión semana a semana', 'Adaptaciones según tu nivel']
}, {
  bono: '🎁 Bono 2',
  title: '🧠 Hábitos y Mentalidad para Triatletas',
  image: 'https://cdn.magicpatterns.com/uploads/p1SkFuKPfs72BmFoAuaVr7/Screenshot_2026-06-06_at_1.40.38_PM.png',
  items: ['Mentalidad de finisher', 'Cómo mantener la motivación', 'Gestión del tiempo', 'Rutinas diarias efectivas', 'Cómo evitar abandonar', 'Disciplina, foco y constancia']
}, {
  bono: '🎁 Bono 3',
  title: '🛡️ Prevención de Lesiones y Movilidad',
  image: 'https://cdn.magicpatterns.com/uploads/8oN1uDMjD4m82xhxEN7QDb/Screenshot_2026-06-06_at_1.41.13_PM.png',
  items: ['Cómo entrenar sin lesionarte', 'Movilidad para triatletas', 'Fortalecimiento preventivo', 'Señales de alerta', 'Recuperación inteligente', 'Vuelta segura después de una molestia']
}, {
  bono: '🎁 Bono 4',
  title: '🥗 Nutrición e Hidratación para Triatletas',
  image: 'https://cdn.magicpatterns.com/uploads/nWCoPvQagBemxdgiuPJxET/Screenshot_2026-06-06_at_1.41.30_PM.png',
  items: ['Qué comer antes de entrenar', 'Qué comer durante entrenamientos largos', 'Qué comer después de entrenar', 'Hidratación según clima y distancia', 'Estrategias simples y efectivas', 'Ejemplos prácticos']
}, {
  bono: '🎁 Bono 5',
  title: '📋 Guías Rápidas y Checklists',
  image: 'https://cdn.magicpatterns.com/uploads/hp1f9D2dgZzyagN9Ttn8Pk/Screenshot_2026-06-06_at_1.41.49_PM.png',
  items: ['Checklist pre-carrera', 'Checklist de equipamiento', 'Checklist para transiciones', 'Guía rápida de ritmos', 'Guía rápida de zonas de entrenamiento', 'Guía rápida de nutrición']
}, {
  bono: '🎁 Bono 6',
  title: '🏆 Estrategias para Tu Primer Triatlón',
  image: 'https://cdn.magicpatterns.com/uploads/hEtf88YZ2Tvy68Yco8AwaJ/Screenshot_2026-06-06_at_2.19.40_PM.png',
  items: ['Errores que frenan a los principiantes', 'Cómo llegar confiado a la carrera', 'Estrategias para debutar sin estrés', 'Consejos de triatletas experimentados', 'Cómo gestionar los nervios', 'Mentalidad ganadora para cruzar la meta']
}];
export function BonosAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-164">
      {bonos.map((b, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`bg-brand-green/5 rounded-2xl border transition-colors overflow-hidden ${isOpen ? 'border-brand-green/50' : 'border-brand-green/20'}`} data-id="element-165">
            {b.image && <div className="relative h-32 sm:h-40 w-full" data-id="element-166">
                <img src={b.image} alt={b.title} className="w-full h-full object-cover object-top" data-id="element-167" />
                <div className="absolute inset-0" style={{
            background: 'linear-gradient(to bottom, rgba(10,10,10,0) 30%, rgba(10,10,10,0.85) 85%, #0a0a0a 100%)'
          }} data-id="element-168" />
              </div>}
            <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center gap-4 text-left focus:outline-none" data-id="element-169">
              <span className="text-xs font-bold tracking-widest uppercase text-brand-green flex-shrink-0" data-id="element-170">
                {b.bono}
              </span>
              <span className="flex-1 font-bold text-base md:text-lg text-white" data-id="element-171">
                {b.title}
              </span>
              <motion.div animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="flex-shrink-0 text-brand-green" data-id="element-172">
                <ChevronDown size={22} data-id="element-173" />
              </motion.div>
            </button>

            <AnimatePresence initial={false} data-id="element-174">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-175">
                  <div className="px-6 pb-6" data-id="element-176">
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-177">
                      {b.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-white/85 text-sm" data-id="element-178">
                          <Check size={16} className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-179" />
                          <span data-id="element-180">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}